<ng-container *ngIf="routerLink$ | async as routerLink">
  <a
    [routerLink]="routerLink"
    [queryParams]="queryParams"
    [class]="anchorClass"
    routerLinkActive="active"
    (isActiveChange)="routerLinkActive = $event"
  >
    <ng-container *ngTemplateOutlet="slottedContent"></ng-container>
  </a>
</ng-container>
<ng-container *ngIf="externalLink$ | async as externalLink">
  <a [href]="externalLink.url" [target]="externalLink.target" [class]="anchorClass">
    <ng-container *ngTemplateOutlet="slottedContent"></ng-container>
  </a>
</ng-container>

<ng-template #slottedContent>
  <ng-content></ng-content>
</ng-template>
